import { cloneDeep } from 'lodash';
import { sendGTMEvent } from '@next/third-parties/google';
import { hasAlreadyTriggered, isNewPaymentModule } from './utils';

export const onPushEvent = (
    event: string,
    params?: Record<string, unknown>,
    prefix?: string,
    onPageLoad?: boolean,
    thoroughCheck?: boolean,
) => {
    const clonedParams = cloneDeep(params);

    if (onPageLoad) {
        const eventObj = event.concat(JSON.stringify(params));

        if (!thoroughCheck && hasAlreadyTriggered(event)) {
            return;
        }

        if (thoroughCheck && hasAlreadyTriggered(event, eventObj, true)) {
            return;
        }
    }

    sendGTMEvent({
        event: `${prefix || ''}${event}`,
        ...clonedParams,
        is_new_payment_module: isNewPaymentModule(),
        version: '4.0.0',
    });
};

export const onPushDimensionEvent = (params?: Record<string, unknown>) => {
    const clonedParams = cloneDeep(params);

    sendGTMEvent({
        ...clonedParams,
        version: '4.0.0',
    });
};
